import LocalizationFieldsContainer from './LocalizationFieldsContainer';

export default LocalizationFieldsContainer;
